<div class="customer-form">
    <div class="container">
        <div class="card p-4">
            <ng-container>
                <div>
                    <label class="label-title">Select Controls</label>
                    <div class="multi-select">
                        <p-multiSelect [options]="controls" [(ngModel)]="selectedControl" [showHeader]="false"
                            (onChange)="typeChange($event)" [filter]="false" optionLabel="name"
                            optionValue="value"></p-multiSelect>
                    </div>
                </div>

                <form action="" [formGroup]="customForm" class="mt-3">
                    <div class="component-body p-0">
                        <div class="component-title">
                            <div class="form-group mb-3">
                                <input type="description" formControlName="title" style="height: 50px;"
                                    class="form-control" placeholder="Title of the component ">
                                <div class="required-error"
                                    *ngIf="customForm.controls['title'].invalid && (customForm.controls['title'].dirty || customForm.controls['title'].touched)">
                                    <div *ngIf="customForm.controls['title'].errors?.['required']">
                                        Title is required.
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-12">
                                <ng-container formArrayName="numberInputWithLabels"
                                    *ngFor="let item of numberInputWithLabelsControls.controls; let i = index; let lastIndex = last">
                                    <ng-container [formGroupName]="i">
                                        <div class="mb-3">
                                            <div class="input-content">
                                                <div class="p-inputgroup">
                                                    <span> <input type="text" style="height: 100%;"
                                                            formControlName="leftLabel" class="form-control"
                                                            placeholder="Enter label" /> </span>

                                                    <span><input type="text" style="height: 100%;" class="form-control"
                                                            formControlName="rightLabel"
                                                            placeholder="Enter unit" /></span>
                                                </div>
                                                <div class="button-section">
                                                    <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                        *ngIf="i !== 0" (click)="removenumberInputWithLabels(i)">
                                                        <mat-icon>remove</mat-icon>
                                                    </button>
                                                    <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                        *ngIf="numberCurrentInd === (i+1)"
                                                        (click)="addnumberInputWithLabels()">
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <ng-container formArrayName="dropdownWithLabel"
                                    *ngFor="let item of dropdownWithLabelControls.controls; let j = index; let lastIndex = last">
                                    <ng-container [formGroupName]="j">
                                        <div class="mb-3">
                                            <div class="input-content">

                                                <div class="d-flex w-100" style="gap: 5px;">
                                                    <div class="p-inputgroup drop me-4">
                                                        <span> <input type="text" formControlName="label"
                                                                class="form-control" placeholder="Enter label" />
                                                        </span>
                                                    </div>
                                                    <div class="w-100" style="margin-top: 4px;">
                                                        <div class="p-chips-container">
                                                            <span>Press enter to separate options (2 minimum)</span>
                                                            <p-chips class="w-100" formControlName="options"
                                                                placeholder="dropdown"></p-chips>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="button-section">
                                                    <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                        *ngIf="j !== 0" (click)="removedropdownWithLabel(j)">
                                                        <mat-icon>remove</mat-icon>
                                                    </button>
                                                    <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                        *ngIf="dropdownCurrentInd === (j+1)"
                                                        (click)="adddropdownWithLabel()">
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <div class="row">
                                    <ng-container formArrayName="checkboxWithLabel"
                                        *ngFor="let item of checkboxWithLabelControls.controls; let k = index; let lastIndex = last">
                                        <ng-container [formGroupName]="k">
                                            <div class="mb-3">
                                                <div class="input-content">
                                                    <div class="d-flex w-100" style="gap: 5px;">
                                                        <div class="p-inputgroup drop me-4">
                                                            <span> <input type="text"
                                                                    style="margin-left: 15px; width: 170px;"
                                                                    formControlName="label" class="form-control"
                                                                    placeholder="Enter label" />
                                                            </span>
                                                        </div>
                                                        <div class="w-100" style="margin-top: 4px;">
                                                            <div class="p-chips-container">
                                                                <span>Press enter to separate options (1 minimum)</span>
                                                                <p-chips formControlName="options"
                                                                    placeholder="checkbox"></p-chips>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="button-section">
                                                        <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                            (click)="removecheckboxWithLabel(k)" *ngIf="k !== 0">
                                                            <mat-icon>remove</mat-icon>
                                                        </button>
                                                        <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                            *ngIf="checkboxCurrentInd === (k+1)"
                                                            (click)="addcheckboxWithLabel()">
                                                            <mat-icon>add</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>

                                <ng-container formArrayName="radioButtons"
                                    *ngFor="let item of radioButtonsControls.controls; let k = index; let lastIndex = last">
                                    <ng-container [formGroupName]="k">
                                        <div class="row" style="align-items: flex-start;">
                                            <div class="d-flex mb-3">
                                                <div class="p-chips-container">
                                                    <span>Press enter to separate options (2 minimum)</span>
                                                    <p-chips class="w-100" formControlName="options"
                                                        placeholder="Options"></p-chips>
                                                </div>


                                                <div class="radio-button" style="margin-left: 20px; margin-top: 10px;">
                                                    <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                        (click)="removeradioButtons(k)" *ngIf="k !== 0">
                                                        <mat-icon>remove</mat-icon>
                                                    </button>
                                                    <button class="m-l-15 mini-button" mat-mini-fab color="primary"
                                                        (click)="addradioButtons(k+1)">
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                            <div class="col-md-6">
                                <ng-container *ngIf="isImage">
                                    <div class="image-box-main">
                                        <div class="w-100">
                                            <div style="display: flex; gap: 20px; align-items: flex-start;">
                                                <!-- Selectors Column -->
                                                <div style="flex: 0 0 auto;">
                                                    <!-- Image Size Selector -->
                                                    <div class="mb-3">
                                                        <label class="form-label">Image Size:</label>
                                                        <select class="form-control" formControlName="imageSize"
                                                            style="width: 105px;">
                                                            <option *ngFor="let size of imageSizes"
                                                                [value]="size.value">
                                                                {{ size.label }}
                                                            </option>
                                                        </select>
                                                    </div>

                                                    <!-- Image Position Selector -->
                                                    <div class="mb-3">
                                                        <label class="form-label">Image Position:</label>
                                                        <select class="form-control" formControlName="imagePosition"
                                                            style="width: 105px;">
                                                            <option *ngFor="let pos of imagePositions"
                                                                [value]="pos.value">
                                                                {{ pos.label }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <!-- Image Preview -->
                                                <div class="image-preview-container">
                                                    <label>
                                                        <img class="preview-image"
                                                            [src]="customForm.controls['image'].value?.length ? customForm.controls['image'].value : selectedImageUrl"
                                                            alt="">
                                                        <input type="file" #fileInput class="form-control"
                                                            accept=".jpg, .jpeg, .png" style="display: none;"
                                                            (change)="selectImage($event)">
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="image-buttons-container">
                                                <button mat-raised-button color="primary"
                                                    (click)="showDialog('bottom', fileInput)">Select from
                                                    gallery</button>
                                                <button mat-raised-button color="primary" class="ms-2"
                                                    (click)="fileInput.click()">Upload Image</button>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                    </div>
                </form>
            </ng-container>
        </div>
    </div>
</div>

<p-dialog header="Media Gallery" [(visible)]="visible" [position]="position"
    [style]="{ width: '50vw', maxHeight: '400px' }" [draggable]="false" [modal]="true">
    <div class="container">
        <div class="row g-2">
            <ng-container *ngFor="let img of galleryImages">
                <div class="col-md-4">
                    <div class="image-container" [class.selected]="selectedImage?.path === img?.path"
                        (click)="toggleImage(img)">
                        <img class="gallery-img" pTooltip="{{img.name}}" [src]="img.path" [alt]="img.name">
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button *ngIf="selectedImage" icon="pi pi-check" (click)="uploadImage()" label="Add"
            styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>